"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractFontMetrics = void 0;
var extractFontMetrics = function (font) {
    return {
        unitsPerEm: font.tables.head.unitsPerEm,
        usWinAscent: font.tables.os2.usWinAscent,
        usWinDescent: font.tables.os2.usWinDescent,
    };
};
exports.extractFontMetrics = extractFontMetrics;
